import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { UncontrolledTooltip } from 'reactstrap';

const FileVersion = ({ file }) => {
  const intl = useIntl();

  return (
    file.created_at !== file.last_upload_at && (
      <span className="file-version">
        <i id="file-has-version" className="far fa-rectangle-history" />
        <span className="file-versions-no">
          <span>&nbsp;{file.versions.length || 0}</span>
        </span>
        <UncontrolledTooltip fade={false} placement="bottom" target="file-has-version">
          {intl.formatMessage({ defaultMessage: 'This file has a version history' })}
        </UncontrolledTooltip>
      </span>
    )
  );
};

FileVersion.propTypes = {
  file: PropTypes.object.isRequired,
};

export default FileVersion;
